<template lang="pug">
v-container(fluid class="tw-pr-6 tw-h-full")
  div(class="tw-flex-col tw-h-full tw-flex")
    v-row(dense class=" tw-flex-grow-0")
      v-col
        kubiqa-contacts-search-autocomplete(:entityType="entityType") 
    v-row(dense align="center" class="tw-pb-0 tw-pt-4 tw--mb-6 ")
      v-col(cols="auto")
        span(class="tw-font-semibold tw-text-gray-700") {{ $t('Listings.Common.contactDetails') }}
      v-col(class="pl-2")
        v-divider(class="tw-border-solid tw-border-t") 

    v-row(align="start" class=" tw-flex-grow ")
      v-form(
        ref="form"
        v-model="valid"
        lazy-validation
        :key="index"
        @keyup.native.enter="valid && addContact($event)"
        class=" tw-p-0 tw-m-0 tw-w-full"
      )
        v-col
          v-row
            v-col
              v-text-field(
                v-model="contact.name"
                :label="$t('Common.name')"
                :rules="nameRules"
                color="blue darken-4"
                required
                outlined
                hide-details
                class="tw-capitalize"
              )
            v-col
              v-text-field(
                v-model="contact.last_name"
                :label="$t('Contacts.Common.lastName')"
                color="blue darken-4"
                required
                outlined
                hide-details
                class="tw-capitalize"
              )
          v-row
            v-col
              v-text-field(
                v-model="contact.email"
                :rules="emailRules"
                :label="$t('Common.email')"
                color="blue darken-4"
                outlined
                hide-details
                class="tw-capitalize"
              )
          v-row
            v-col
              v-text-field(
                v-model="contact.phone"
                :label="$t('Common.phone')"
                color="blue darken-4"
                required
                outlined
                hide-details
                class="tw-capitalize"
              )
            v-col
              v-select(
                v-model="contact.type"
                :label="$t('Settings.Common.role')"
                :items="contactType"
                :rules="roleRules"
                color="blue darken-4"
                outlined
                hide-details
                class="tw-capitalize"
              )
    v-row(justify="end" class="tw-flex-grow-0")
      v-col(cols="auto" class="tw-pb-0")
        v-btn(
          depressed
          outlined
          @click="addContact()"
          :loading="loading"
          color="indigo darken-2"
          class="tw-m-0 tw-p-0"
        )
          span {{ $t('Common.add') }}
</template>
<script>
export default {
  props: {
    entityType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      contactType: ['Owner', 'Agent', 'Lawyer', 'Representative', 'Other'],
      contactsSearch: null,
      contactsLoading: false,
      loading: false,
      valid: true,
      index: 1,
      emailRules: [(v) => !!v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'],
      roleRules: [(v) => !!v || "Please select the contact's role"],
      nameRules: [(v) => !!v || "Please select the contact's name"],
    };
  },
  computed: {
    contact() {
      return this.$store.getters[this.entityType + '/contacts/current_contact'];
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.error = true;
        this.error_message = 'error';
      }
    },
    addContact() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch(this.entityType + '/contacts/relateContact', this.contact)
          .then((response) => {
            this.contact = {};
            this.valid = true;
            this.index++;
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      }
    },
    getContacts() {},
  },
};
</script>
